module.exports = "https://static.wmbcdn.com/uniweb/images/f83a6dd69d8a063be3975ce0c1edc58c.svg";